    
<template>
    <div class="dashBox">
        <div class="dashTitle">关注系统异常分布饼图 (点击可进入趋势分析)</div>
        <a-empty v-if="data.listerrorsys.length == 0" description="暂无数据，定时任务是否执行或是否关注系统？" style="margin-top:80px;"  />

        <div id="zppiediv"  style="width: 100%;"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            chartSys:null,
        }
    },
    props:{
        data:{
            listerrorsys:[]
        }
    },
    methods: {
        //按日期统计数据
        analystData(){
            let that = this;
            if(that.data.listerrorsys.length == 0){
                if(that.chartSys){
                    that.chartSys.clear();
                    document.getElementById('zppiediv').style.height = "0";
                }
                return
            }
            if(that.chartSys){
                that.chartSys.clear();
            }
            document.getElementById("zppiediv").style.height = "360px";
            that.chartSys = that.$echarts.init(document.getElementById("zppiediv"));
            
            let option = that.getDatailOption();
            // 窗口大小自适应方案
            that.chartSys.setOption(option);
            that.chartSys.off('click');
            that.chartSys.on('click', function (params) {
                that.$router.push({
                    path: "/monitorerror/trend",
                    query:{
                        sysname:params.name
                    }
                });
            });
            
        },
        getDatailOption(){
            let that = this;
            if(that.data.listerrorsys.length == 0){
                return
            }
            let resultData = [];
            let array = that.data.listerrorsys;
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                resultData.push({
                    name:element.logstorename,
                    value:element.value
                })
            }
           
            // 基于准备好的dom，初始化echarts实例
            // 绘制图表配置
            let option = {
                title: {
                    show:false
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    right: '5px',
                    top:'bottom'
                },
                color:that.G.getChartColors(),
                series: [
                    {
                        name: '异常数',
                        type: 'pie',
                        radius: '50%',
                        data: resultData,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };
            return option
        },
        chartResize(){
            let eleArr = [this.chartSys,this.chartDetail];
            for(let i = 0; i<eleArr.length; i++){
                //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
                setTimeout(function(){
                    if(eleArr[i]){
                        eleArr[i].resize();
                    }
                }, 200);
            }
        },
    },
    mounted() {
        window.addEventListener("resize", this.chartResize);
    },
    watch:{
        'data.listerrorsys'(newVal){
            if(newVal){
                this.analystData();
            }
        }
    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);

    }
}
</script>

<style scoped>
    .dashBox{
        min-height: 395px;
        border: 1px solid lightgray;
        padding-bottom: 20px;
        background-color: white;

    }
    .dashTitle{
        width: 100%;
        height: 40px;
        color: #00c1de;
        line-height:38px;
        padding:0 10px;
        border-bottom: 1px solid lightgray;
    cursor: default;

    }
</style>

<style>
  #homeRequestBox .ant-card-body{
        padding-top: 0;
    }
</style>